var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 text--primary pt-3"},[_vm._v(" "+_vm._s(_vm.categoryName)+" ")]),_vm._l((_vm.itemsInCategory),function(item){return _c('div',{key:item.uuid},[_c('AdditionalItem',{attrs:{"item":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }